import React, { Component } from "react";

import {
  Table,
  Tag,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  InputNumber,
  DatePicker,
  Popconfirm,
  message,
  Collapse,
} from "antd";

import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import {
  createNewReWind,
  getReWindDetails,
  UpdateReWind,
  dataUpdateGeneralDetails,
} from "../../api/index";
import moment from "moment";
import { checkServiceType } from "../../actions/service-type";
import AssetDelete from "../site_components/asset_delete";

class Rew extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();

    this.state = {
      title: "",
      actionView: false,
      tabaleLoading: false,
      open: false,
      openEdit: false,
      selectedMakeId: null,
      makeType: [],

      rewWindPotential: "",
      rewPerWindTurbineCapacity: "",
      rewWindTurbineCount: "",
      rewInstalledLocation: "",
      rewInstalledHeight: "",
      rewEnergyFeed: "",
      rewRmsconnectionInband: "",
      rewRmsconnectionMode: "",
      rewCommissionedDate: null,
      AssetManagementPermission: false,
      openViewMoreDetails: false,
      selectedElement: "",
      rectifier: [],
      selectedRectifierList: [],
      switchStatus: true,
      objectSet: {
        resExpectedEnergyGenerationFromWind: 0,
        resAverageEnergyGenerationFromWind: 0,
        windPotential: null,
      },

      dropdownObjWind: {
        rewPotential: "",
        rewWindTurbineCount: "",
        rewInstalledLocation: "",
        rewRmsconnectionInband: "",
        rewEnergyFeed: "",
      },
    };
    this.requestFromClose = this.requestFromClose.bind(this);
    this.handleWindPotential = this.handleWindPotential.bind(this);
    this.handleperWindTurbineCapacity =
      this.handleperWindTurbineCapacity.bind(this);
    this.handleInstalledLocation = this.handleInstalledLocation.bind(this);
    this.handleInstalledHeight = this.handleInstalledHeight.bind(this);
    this.handleRmsconnectionInband = this.handleRmsconnectionInband.bind(this);
    this.handleRmsconnectionMode = this.handleRmsconnectionMode.bind(this);
    this.handleEnergyFeed = this.handleEnergyFeed.bind(this);
    this.handleWindTurbineCount = this.handleWindTurbineCount.bind(this);
  }
  requestFromClose() {
    console.log("dsdsd");
    this.setState({ showModal: true, open: true });
  }
  handleWindTurbineCount(e) {
    console.log(e);
    this.setState({ rewWindTurbineCount: Math.round(e) });
  }
  handleEnergyFeed(e) {
    this.setState({ rewEnergyFeed: e });
  }
  handleRmsconnectionMode(e) {
    this.setState({ rewRmsconnectionMode: e });
  }
  handleRmsconnectionInband(e) {
    this.setState({ rewRmsconnectionInband: e });
  }
  handleInstalledHeight(e) {
    console.log(e);
    this.setState({ rewInstalledHeight: e });
  }
  handleInstalledLocation(e) {
    this.setState({ rewInstalledLocation: e });
  }
  handleperWindTurbineCapacity(e) {
    console.log(e);
    this.setState({ rewPerWindTurbineCapacity: e });
  }
  handleWindPotential(e) {
    this.setState({ rewWindPotential: e });
  }
  onChangeCommissionedDate = (date, dateString) => {
    console.log(date);
    console.log(dateString);
    this.setState({
      rewCommissionedDate: dateString,
    });
  };
  onChangeRectifier = (value) => {
    var _tempList = [];
    value.map((e) => {
      _tempList.push({ id: e });
    });
    this.setState({
      rectifier: _tempList,
    });
  };
  RewUpdata(id) {
    // console.log('dfdfd')
    console.log(id);
    this.getDataReWindDetails(id);
    this.setState({ openEdit: true });
  }
  getDataReWindDetails = async (id) => {
    console.log("s34");
    this.setState({
      selectedRectifierList: [],
    });

    var res = await getReWindDetails(id);
    console.log(res);
    if (res.success) {
      this.setState({
        REWId: res.data?.id,
        REWEdit: res.data,
        selectedMakeId: res.data?.make?.id,
        makeType: res.data?.make,

        rewWindPotential: res.data?.windPotential,
        rewPerWindTurbineCapacity: res.data?.perWindTurbineCapacity,
        rewWindTurbineCount: res.data?.windTurbineCount,
        rewInstalledLocation: res.data?.installedLocation,
        rewInstalledHeight: res.data?.installedHeight,
        rewEnergyFeed: res.data?.energyFeed,
        rewRmsconnectionInband: res.data?.rmsconnectionInband,
        rewRmsconnectionMode: res.data?.rmsconnectionMode,
        rectifier: res.data.rectifiers,
      });
      if (res.data.rectifiers != null) {
        res.data.rectifiers
          ?.filter((name) => name.delete == false)
          .map((e) => this.state.selectedRectifierList.push(e.id));
      }
      if (res.data?.commissionedDate != null) {
        this.setState({
          rewCommissionedDate: res.data?.commissionedDate,
        });
      } else {
        this.setState({
          rewCommissionedDate: "",
        });
      }
    }
  };
  onDrawerClose = () => {
    console.log("sddsds");
    this.formRef.current.resetFields();
    this.validator.hideMessages();

    this.setState({
      open: false,
      openEdit: false,
      selectedMakeId: null,
      makeType: [],

      rewWindPotential: "",
      rewPerWindTurbineCapacity: "",
      rewWindTurbineCount: "",
      rewInstalledLocation: "",
      rewInstalledHeight: "",
      rewEnergyFeed: "",
      rewRmsconnectionInband: "",
      rewRmsconnectionMode: "",
      rewCommissionedDate: null,
      selectedElement: "",
      rectifier: [],
      selectedRectifierList: [],
    });
  };
  AllDataSubmitUpdate = async () => {
    if (this.validator.allValid()) {
      var dataSet;
      dataSet = {
        site: { id: this.props?.detailsSite?.site_details.id },
        asset: {
          id: 2,
        },
        id: this.state.REWId,

        make: this.state.makeType,
        windPotential: this.state.rewWindPotential,
        perWindTurbineCapacity: this.state.rewPerWindTurbineCapacity,
        windTurbineCount: this.state.rewWindTurbineCount,
        installedLocation: this.state.rewInstalledLocation,
        installedHeight: this.state.rewInstalledHeight,
        commissionedDate: this.state.rewCommissionedDate,
        energyFeed: this.state.rewEnergyFeed,
        rmsconnectionInband: this.state.rewRmsconnectionInband,
        rmsconnectionMode: this.state.rewRmsconnectionMode,
        rectifiers: this.state.rectifier,
      };
      console.log(dataSet);
      var res = await UpdateReWind(dataSet);
      console.log(res);
      if (res.success) {
        message.success("Successfully Renewable Energy Wind Edited!");
        this.formRef.current.resetFields();
        this.setState(
          {
            showModal: false,
            open: false,
            openEdit: false,
            selectedMakeId: null,
            makeType: [],

            rewWindPotential: "",
            rewPerWindTurbineCapacity: "",
            rewWindTurbineCount: "",
            rewInstalledLocation: "",
            rewInstalledHeight: "",
            rewEnergyFeed: "",
            rewRmsconnectionInband: "",
            rewRmsconnectionMode: "",
            rewCommissionedDate: null,
            rectifier: [],
            selectedRectifierList: [],
          },
          () => {
            console.log("selectedRectifierList");
            console.log(this.state.selectedRectifierList);
          }
        );
        this.props.parentMethod();
      } else {
        message.warning(" Something went wrong!");
      }
    } else {
      console.log(this.validator);
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
    }
  };
  AllDataSubmit = async () => {
    if (this.validator.allValid()) {
      var dataSet;
      dataSet = {
        site: { id: this.props?.detailsSite?.site_details.id },
        asset: {
          id: 2,
        },
        make: this.state.makeType,
        windPotential: this.state.rewWindPotential,
        perWindTurbineCapacity: this.state.rewPerWindTurbineCapacity,
        windTurbineCount: this.state.rewWindTurbineCount,
        installedLocation: this.state.rewInstalledLocation,
        installedHeight: this.state.rewInstalledHeight,
        commissionedDate: this.state.rewCommissionedDate,
        energyFeed: this.state.rewEnergyFeed,
        rmsconnectionInband: this.state.rewRmsconnectionInband,
        rmsconnectionMode: this.state.rewRmsconnectionMode,
        rectifiers: this.state.rectifier,
      };
      console.log(dataSet);
      var res = await createNewReWind(dataSet);
      console.log(res);
      if (res.success) {
        message.success("Successfully Renewable Energy Wind Added!");
        this.setState({
          showModal: false,
          open: false,

          selectedMakeId: null,
          makeType: [],

          rewWindPotential: "",
          rewPerWindTurbineCapacity: "",
          rewWindTurbineCount: "",
          rewInstalledLocation: "",
          rewInstalledHeight: "",
          rewEnergyFeed: "",
          rewRmsconnectionInband: "",
          rewRmsconnectionMode: "",
          rewCommissionedDate: null,
          rectifier: [],
          selectedRectifierList: [],
        });
        this.props.parentMethod();
      } else {
        message.warning(" Something went wrong!");
      }
    } else {
      console.log(this.validator);
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
    }
  };

  componentDidMount() {
    if (JSON.parse(localStorage.getItem("serviceTypeSet")) == null) {
      const { history } = this.props;
      history.push("/");
    } else {
      this.getSetPageData(
        JSON.parse(localStorage.getItem("serviceTypeSet")),
        38
      );
    }

    checkServiceType(38).then((data) =>
      this.setState(
        {
          AssetManagementPermission: data,
        },
        () => {}
      )
    );
    this.setState({
      objectSet: {
        resExpectedEnergyGenerationFromWind:
          this.props?.details.access_technologies_data
            ?.resExpectedEnergyGenerationFromWind,
        resAverageEnergyGenerationFromWind:
          this.props?.details.access_technologies_data
            ?.resAverageEnergyGenerationFromWind,
        rewWindPotential:
          this.props?.details.access_technologies_data?.rewWindPotential,
      },
    });
  }

  getSetPageData = (serviceTypeIs, Pageid) => {
    if (
      serviceTypeIs.serviceType.filter(
        (checkuser) => checkuser?.id == Pageid
      )[0] != null
    ) {
      console.log("fddf");
      this.setState({
        actionView: true,
      });
    }
  };
  onChangeMake = (value) => {
    console.log("onChangeMake");
    //console.log(value);
    this.setState({
      selectedMakeId: value,
      makeType: {
        id: value,
      },
    });
  };

  viewMoreDetails(element) {
    this.setState({
      showModal2: true,
      openViewMoreDetails: true,
      selectedElement: element,
    });
  }

  onViewMoreDetailsDrawerClose = () => {
    this.setState({
      showModal2: false,
      openViewMoreDetails: false,
    });
  };

  validatedTextLable = (field) => {
    return field !== null && field !== "" ? (
      <span class="badge badge-outline-secondary text-muted">{field}</span>
    ) : (
      <span class="badge text-danger">Currently Not Set</span>
    );
  };
  submitForm = async (item) => {
    this.getDataDetailsForDelete(item);
  };
  getDataDetailsForDelete = async (id) => {
    var res = await getReWindDetails(id);
    console.log(res);
    if (res.success) {
      var respons = AssetDelete.Action(
        res.data,
        this.props?.detailsSite?.site_details.id,
        UpdateReWind
      );

      respons.then((value) => {
        if (value == 1) {
          message.success("Successfully Delete!");
          this.props.parentMethod();
        } else {
          message.warning(" Something went wrong!");
        }
      });
    }
  };
  handlresresAverageEnergyGenerationFromWind = (e) => {
    this.setState(
      {
        objectSet: {
          ...this.state.objectSet,
          resAverageEnergyGenerationFromWind: e,
        },
      },
      () => {
        console.log(this.state.objectSet);
      }
    );
  };

  handlresresExpectedEnergyGenerationFromWind = (e) => {
    this.setState(
      {
        objectSet: {
          ...this.state.objectSet,
          resExpectedEnergyGenerationFromWind: e,
        },
      },
      () => {
        console.log(this.state.objectSet);
      }
    );
  };

  dataUpdate() {
    console.log("ssss");
    this.setState({
      switchStatus: false,
    });
  }
  close = async () => {
    this.props.parentMethod();
    this.setState({
      objectSet: {
        resExpectedEnergyGenerationFromWind:
          this.props?.details.access_technologies_data
            ?.resExpectedEnergyGenerationFromWind,
        resAverageEnergyGenerationFromWind:
          this.props?.details.access_technologies_data
            ?.resAverageEnergyGenerationFromWind,
        windPotential:
          this.props?.details.access_technologies_data?.windPotential,
      },
    });
    this.setState({
      switchStatus: true,
    });
  };
  dataSetToUpdate = async () => {
    console.log(this.state.objectSet);
    console.log(this.props.detailsupdateGeneralDetails.updateGeneralDetails);
    let remoteJob = {
      ...this.props.detailsupdateGeneralDetails.updateGeneralDetails,
      ...this.state.objectSet,
    };
    const formData = new FormData();
    formData.append("id", this.props?.details?.access_technologies_data?.id);
    formData.append("object", JSON.stringify(remoteJob));

    var res = await dataUpdateGeneralDetails(formData);

    if (res.success) {
      message.success("Successfully Update!");
      this.props.parentMethod();
      this.setState({
        switchStatus: true,
      });
    } else {
      message.warning(" Something went wrong!");
    }
  };
  render() {
    const { Option } = Select;
    const { Panel } = Collapse;
    const _rew = this.state.selectedElement;
    const columns2 = [
      {
        title: "Wind Turbine Capacity of a single unit (kW)",
        details: [],
        content: this.validatedTextLable(_rew.perWindTurbineCapacity),
      },
      {
        title: "Wind Turbine Count",
        details: [],
        content: this.validatedTextLable(_rew.windTurbineCount),
      },
      {
        title: "Installed Location",
        details: [],
        content: this.validatedTextLable(_rew.installedLocation),
      },
      {
        title: "Installed Height (m)",
        details: [],
        content: this.validatedTextLable(_rew.installedHeight),
      },
      {
        title: "Commissioned Date",
        details: [],
        content: this.validatedTextLable(_rew.commissionedDate),
      },
      {
        title: "Make",
        details: [],
        content:
          _rew !== "" ? (
            <Tag color="gray" style={{ margin: "0px" }}>
              <span>{_rew.make?.name}</span>
            </Tag>
          ) : (
            <></>
          ),
      },
      {
        title: "RMS connection Inband/Outband",
        details: [],
        content: this.validatedTextLable(_rew.rmsconnectionInband),
      },
      {
        title: "RMS Connection Mode",
        details: [],
        content: this.validatedTextLable(_rew.rmsconnectionMode),
      },
      {
        title: "Energy feed onto the DC/AC bus",
        details: [],
        content: this.validatedTextLable(_rew.energyFeed),
      },
      // {
      //     title: "Wind Potential",
      //     details: [],
      //     content: this.validatedTextLable(_rew.windPotential),
      // },
      {
        title: "Rectifiers",
        details: [],
        content:
          _rew !== "" ? (
            _rew.rectifiers.filter((name) => name.delete == false).length !=
            0 ? (
              <div class="d-flex justify-content-end align-items-center">
                {_rew.rectifiers
                  .filter((name) => name.delete == false)
                  .map((e) => (
                    <span
                      class="badge badge-soft-pink fw-semibold"
                      style={{ marginLeft: "5px" }}
                    >
                      {e.name}
                    </span>
                  ))}
              </div>
            ) : (
              <span class="badge badge-outline-secondary text-muted">No</span>
            )
          ) : (
            <></>
          ),
      },
    ];

    return (
      <>
        <div className="row">
          <div className="row">
            <div class="col-lg-12">
              <div class="text-end">
                <ul class="list-inline">
                  <li class="list-inline-item">
                    {this.state.actionView ? (
                      <button
                        type="button"
                        class="btn btn-soft-primary btn-sm"
                        onClick={this.requestFromClose}
                      >
                        <i class="fas fa-plus me-2"></i>Add Renewable Energy
                        Wind
                      </button>
                    ) : (
                      ""
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex justify-content-between align-items-center">
                    <h4 class="card-title">Information</h4>
                    {this.state.switchStatus ? (
                      <button
                        type="button"
                        class="btn btn-soft-primary btn-icon-square-sm"
                        onClick={() => this.dataUpdate()}
                      >
                        {" "}
                        <i class="mdi mdi-pencil-outline"></i>
                      </button>
                    ) : (
                      <div class="d-flex justify-content-end align-items-center">
                        <button
                          type="button"
                          class="btn btn-soft-secondary "
                          onClick={() => this.close()}
                          style={{ marginRight: "10px" }}
                        >
                          {" "}
                          Cancel{" "}
                        </button>
                        <button
                          type="button"
                          class="btn btn-soft-primary "
                          onClick={() => this.dataSetToUpdate()}
                        >
                          {" "}
                          Submit to Update{" "}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div className="col-md-6 mt-1">
                      <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <div>
                            <i className="la la-hand-o-right text-primary me-2"></i>{" "}
                            Wind Potential
                          </div>
                          {this.state.switchStatus ? (
                            <>
                              {this.props.details.access_technologies_data
                                ?.windPotential != null ? (
                                <span className="badge badge-outline-success">
                                  {
                                    this.props?.details.access_technologies_data
                                      ?.windPotential
                                  }
                                </span>
                              ) : (
                                <span className="badge badge-outline-warning">
                                  Currently Not Set
                                </span>
                              )}
                            </>
                          ) : (
                            <>
                              <Select
                                style={{ width: "30%" }}
                                value={this.state.objectSet?.windPotential}
                                onChange={(selectedValue) => {
                                  this.setState(
                                    (prevState) => ({
                                      objectSet: {
                                        ...prevState.objectSet,
                                        windPotential: selectedValue,
                                      },
                                    }),
                                    () => {
                                      console.log(this.state.objectSet);
                                    }
                                  );
                                }}
                              >
                                {this.props?.windDropdown["dropdownObjWind"][
                                  "rewPotential"
                                ]?.map((x, y) => (
                                  <Option key={y} value={x}>
                                    {x}
                                  </Option>
                                ))}
                              </Select>
                            </>
                          )}
                        </li>
                      </ul>
                    </div>

                    <div className="col-md-6 mt-1">
                      <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          <div>
                            <i class="la la-hand-o-right text-primary me-2"></i>{" "}
                            Expected energy generation from wind (kWh / day)
                          </div>
                          {this.state.switchStatus ? (
                            <>
                              {this.props?.details.access_technologies_data
                                ?.resExpectedEnergyGenerationFromWind !=
                              null ? (
                                <span class="badge badge-outline-success">
                                  {
                                    this.props?.details.access_technologies_data
                                      ?.resExpectedEnergyGenerationFromWind
                                  }
                                </span>
                              ) : (
                                <span class="badge badge-outline-warning">
                                  Currently Not Set
                                </span>
                              )}
                            </>
                          ) : (
                            <>
                              {" "}
                              <InputNumber
                                min={0}
                                style={{ width: "30%" }}
                                value={
                                  this.state.objectSet
                                    ?.resExpectedEnergyGenerationFromWind
                                }
                                id="airCoolingMethod"
                                onChange={
                                  this
                                    .handlresresExpectedEnergyGenerationFromWind
                                }
                              />{" "}
                            </>
                          )}
                        </li>
                      </ul>
                    </div>

                    <div className="col-md-6 mt-1">
                      <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          <div>
                            <i class="la la-hand-o-right text-primary me-2"></i>{" "}
                            Average energy generation from wind (kWh / day)
                          </div>
                          {this.state.switchStatus ? (
                            <>
                              {this.props?.details.access_technologies_data
                                ?.resAverageEnergyGenerationFromWind != null ? (
                                <span class="badge badge-outline-success">
                                  {
                                    this.props?.details.access_technologies_data
                                      ?.resAverageEnergyGenerationFromWind
                                  }
                                </span>
                              ) : (
                                <span class="badge badge-outline-warning">
                                  Currently Not Set
                                </span>
                              )}
                            </>
                          ) : (
                            <>
                              {" "}
                              <InputNumber
                                min={0}
                                style={{ width: "30%" }}
                                value={
                                  this.state.objectSet
                                    ?.resAverageEnergyGenerationFromWind
                                }
                                id="airCoolingMethod"
                                onChange={
                                  this
                                    .handlresresAverageEnergyGenerationFromWind
                                }
                              />{" "}
                            </>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.props.details2.renewableEnergyWind_data.map((element) => (
            <div className="col-md-4">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex justify-content-start align-items-center">
                    <img
                      src={
                        "https://static.vecteezy.com/system/resources/previews/001/902/502/large_2x/telecommunication-radio-antenna-and-satelite-tower-with-blue-sky-free-photo.JPG"
                      }
                      alt=""
                      class="thumb-md rounded"
                    />
                    <div
                      class="badge badge-soft-primary"
                      style={{
                        padding: "5px",
                        marginLeft: "15px",
                        border: "1px solid rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <i
                        class="la la-home font-14 text-dark"
                        style={{ paddingLeft: "10px" }}
                      />
                      <i
                        class="la la-angle-right text-dark font-14"
                        style={{ padding: "5px" }}
                      />
                      <span class="fw-semibold text-pink">
                        {element.rectifiers != null &&
                        element.rectifiers.length > 0
                          ? element.rectifiers[0].name +
                            (element.rectifiers.filter(
                              (name) => name.delete == false
                            ).length > 1
                              ? " ..."
                              : "")
                          : ""}
                      </span>
                      <i
                        class="la la-angle-right text-dark font-14"
                        style={{ padding: "5px" }}
                      />
                      <span
                        class="fw-semibold text-primary"
                        style={{ paddingRight: "10px" }}
                      >
                        {element.make?.name}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="col">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="fw-normal m-0">Make</h6>
                      <span class="badge bg-secondary">
                        {element.make?.name}
                      </span>
                    </div>
                    {/* <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="fw-normal m-0">Wind Potential</h6>
                                            <span class="badge badge-outline-info badge-pill">{element.windPotential}</span>
                                        </div> */}
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="fw-normal m-0">Wind Turbine Count</h6>
                      <span class="badge badge-soft-dark fw-semibold">
                        <i class="far fa-fw dripicons-help"></i>{" "}
                        {element.windTurbineCount}
                      </span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="fw-normal m-0">Installed</h6>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-soft-warning fw-semibold ms-2">
                          <i class="far fa-fw dripicons-location"></i>{" "}
                          {element.installedLocation}{" "}
                        </span>
                        <span class="badge badge-soft-success fw-semibold ms-2">
                          <i class="far fa-fw ti-ruler"></i>{" "}
                          {element.installedHeight} m Hight
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="card-footer m-0">
                  <div class="d-flex justify-content-between align-items-center">
                    <a
                      href="#custom-modal"
                      class="btn btn-soft-dark btn-sm waves-effect btn-round"
                      onClick={() => this.viewMoreDetails(element)}
                    >
                      <i class="mdi mdi mdi-unfold-more-horizontal"></i> More
                      Details{" "}
                    </a>
                    <div class="text-end">
                      {this.state.AssetManagementPermission ? (
                        <button
                          type="button"
                          class="btn btn-soft-primary btn-icon-square-sm"
                          onClick={() => this.RewUpdata(element.id)}
                          style={{ marginRight: "0px" }}
                        >
                          <i class="mdi mdi-pencil-outline"></i>
                        </button>
                      ) : (
                        ""
                      )}
                      <Popconfirm
                        title="Are You Sure?"
                        description="Are you sure to delete this task?"
                        onConfirm={() => this.submitForm(element.id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        {this.state.AssetManagementPermission ? (
                          <button
                            type="button"
                            class="btn btn-soft-danger btn-icon-square-sm"
                          >
                            <i class="mdi mdi-trash-can-outline"></i>
                          </button>
                        ) : (
                          ""
                        )}
                      </Popconfirm>
                    </div>
                  </div>
                </p>
              </div>
            </div>
          ))}

          <Drawer
            maskClosable={false}
            title={"Renewable Energy Wind Details"}
            width={"50%"}
            placement="right"
            onClose={() => this.onViewMoreDetailsDrawerClose()}
            visible={this.state.openViewMoreDetails}
            closeIcon={
              <button
                type="button"
                class="btn btn-soft-danger btn-icon-square-sm"
                style={{ marginRight: "8px" }}
              >
                <i class="mdi dripicons-cross"></i>
              </button>
            }
          >
            <Collapse
              style={{ borderColor: "lavender", alignContent: "center" }}
            >
              {columns2.map((item) => (
                <Panel
                  style={{ borderColor: "lavender" }}
                  header={
                    <li class="d-flex justify-content-between align-items-center">
                      <div>
                        {item.details.length == 0 ? (
                          <i
                            class="la la-hand-o-right text-primary"
                            style={{ paddingLeft: "5px", paddingRight: "5px" }}
                          />
                        ) : (
                          <></>
                        )}
                        <span class="fw-normal m-2">{item.title}</span>
                      </div>
                      {item.content}
                    </li>
                  }
                  key={item.title}
                  showArrow={item.details.length > 0}
                  collapsible={item.details.length > 0 ? "" : "icon"}
                >
                  {item.details.map((detail) => (
                    <li
                      class="d-flex justify-content-between align-items-center me-2"
                      style={{ paddingBottom: "10px", paddingLeft: "10px" }}
                    >
                      <div>
                        <i class="la la-circle text-primary me-2"></i>{" "}
                        <span>{detail.title}</span>
                      </div>
                      {detail.content}
                    </li>
                  ))}
                </Panel>
              ))}
            </Collapse>
          </Drawer>
        </div>

        <Drawer
          maskClosable={false}
          title={"New Renewable Energy Wind"}
          width={"60%"}
          placement="right"
          onClose={() => this.onDrawerClose()}
          visible={this.state.open}
          closeIcon={
            <button
              type="button"
              class="btn btn-soft-danger btn-icon-square-sm"
              style={{ marginRight: "8px" }}
            >
              <i class="mdi dripicons-cross"></i>
            </button>
          }
        >
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <Form ref={this.formRef}>
                    <div className="row"></div>

                    <div className="row">
                      <div className="col-md-6">
                        <label
                          className="form-label"
                          for="rewPerWindTurbineCapacity"
                        >
                          Wind Turbine Capacity of a single unit (kW){" "}
                          <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item
                          required
                          name="perWindTurbineCapacity"
                          tooltip="This is a required field"
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            id="perWindTurbineCapacity"
                            onChange={this.handleperWindTurbineCapacity}
                          />
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Wind Turbine Capacity of a single unit (kW)",
                              this.state.rewPerWindTurbineCapacity,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label" for="depot">
                          Wind Turbine Count <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item>
                          {/* <InputNumber style={{ width: '100%' }} id="windTurbineCount" value={this.state.rewWindTurbineCount} onChange={this.handleWindTurbineCount} /> */}
                          <div>
                            <Select
                              style={{ width: "100%" }}
                              id="windTurbineCount"
                              onChange={(e) => {
                                this.handleWindTurbineCount(e);
                              }}
                            >
                              {this.props.windDropdown["dropdownObjWind"][
                                "rewWindTurbineCount"
                              ]?.map((x) => {
                                return <Option value={x}>{x}</Option>;
                              })}
                            </Select>
                          </div>
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Wind Turbine Count",
                              this.state.rewWindTurbineCount,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          Installed Location <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item
                          required
                          name="installedLocation"
                          tooltip="This is a required field"
                        >
                          {/* <Input id="installedLocation" onChange={this.handleInstalledLocation} /> */}
                          <div>
                            <Select
                              style={{ width: "100%" }}
                              id="installedLocation"
                              onChange={(e) => {
                                this.handleInstalledLocation(e);
                              }}
                            >
                              {this.props.windDropdown["dropdownObjWind"][
                                "rewInstalledLocation"
                              ]?.map((x) => {
                                return <Option value={x}>{x}</Option>;
                              })}
                            </Select>
                          </div>
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Installed Location",
                              this.state.rewInstalledLocation,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          Installed Height (m) <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item
                          required
                          name="installedHeight"
                          tooltip="This is a required field"
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            id="installedHeight"
                            onChange={this.handleInstalledHeight}
                          />
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              " Installed Height",
                              this.state.rewInstalledHeight,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label" for="depot">
                          Commissioned Date
                        </label>
                        <Form.Item
                          required
                          name="commissionedDate"
                          tooltip="This is a required field"
                        >
                          <DatePicker
                            style={{ width: "100%" }}
                            onChange={this.onChangeCommissionedDate}
                          />
                          {/* <p style={{ color: "#f5325c" }}>{this.validator2.message('depot', this.state.siteOnAirDate, 'required')}</p> */}
                        </Form.Item>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label" for="depot">
                          Make <x style={{ color: "red" }}>*</x>
                        </label>

                        <Form.Item
                          required
                          name="Is_active"
                          tooltip="This is a required field"
                        >
                          <Select
                            showSearch
                            onChange={this.onChangeMake}
                            style={{ width: "100%" }}
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                          >
                            {this.props.rewMasterData?.rewMasterData?.rewMakelList?.map(
                              (item, index) => {
                                return (
                                  <Option value={item?.id}>{item?.name}</Option>
                                );
                              }
                            )}
                          </Select>

                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Make",
                              this.state.selectedMakeId,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          RMS connection Inband/Outband
                        </label>
                        <Form.Item
                          required
                          name="rmsconnectionInband"
                          tooltip="This is a required field"
                        >
                          {/* <Input id="rmsconnectionInband" onChange={this.handleRmsconnectionInband} /> */}
                          <div>
                            <Select
                              style={{ width: "100%" }}
                              id="rmsconnectionInband"
                              onChange={(e) => {
                                this.handleRmsconnectionInband(e);
                              }}
                            >
                              {this.props.windDropdown["dropdownObjWind"][
                                "rewRmsconnectionInband"
                              ]?.map((x) => {
                                return <Option value={x}>{x}</Option>;
                              })}
                            </Select>
                          </div>
                          {/* <p style={{ color: "#f5325c" }}>{this.validator.message('site_name', this.state.siteName, 'required')}</p> */}
                        </Form.Item>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          RMS Connection Mode
                        </label>
                        <Form.Item
                          required
                          name="rmsconnectionMode"
                          tooltip="This is a required field"
                        >
                          {/* <Input id="rmsconnectionMode" onChange={this.handleRmsconnectionMode} /> */}
                          <Select
                            showSearch
                            style={{ width: "100%" }}
                            id="rmsconnectionMode"
                            onChange={(e) => {
                              this.handleRmsconnectionMode(e);
                            }}
                          >
                            {this.props?.windDropdown["dropdownObjWind"][
                              "rewRmsconnectionMode"
                            ]?.map((x) => {
                              return <Option value={x}>{x}</Option>;
                            })}
                          </Select>
                          {/* <p style={{ color: "#f5325c" }}>{this.validator.message('site_name', this.state.siteName, 'required')}</p> */}
                        </Form.Item>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          Energy feed onto the DC/AC bus{" "}
                          <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item
                          required
                          name="energyFeed"
                          tooltip="This is a required field"
                        >
                          {/* <Input id="energyFeed" onChange={this.handleEnergyFeed} /> */}
                          <div>
                            <Select
                              style={{ width: "100%" }}
                              id="energyFeed"
                              onChange={(e) => {
                                this.handleEnergyFeed(e);
                              }}
                            >
                              {this.props.windDropdown["dropdownObjWind"][
                                "rewEnergyFeed"
                              ]?.map((x) => {
                                return <Option value={x}>{x}</Option>;
                              })}
                            </Select>
                          </div>
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Energy feed onto the DC/AC bus",
                              this.state.rewEnergyFeed,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label" for="depot">
                          Rectifiers <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item
                          required
                          name="Is_active"
                          tooltip="This is a required field"
                        >
                          <Select
                            mode="multiple"
                            showSearch
                            onChange={this.onChangeRectifier}
                            style={{ width: "100%" }}
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                          >
                            {this.props.rewMasterData?.rewMasterData?.rectifierList?.map(
                              (item, index) => {
                                return (
                                  <Option value={item?.id}>{item?.name}</Option>
                                );
                              }
                            )}
                          </Select>
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Rectifiers",
                              this.state.rectifier,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>
                    </div>
                  </Form>
                  <div className="row" style={{ justifyContent: "end" }}>
                    <div className="col-md-2">
                      {" "}
                      <button
                        className="btn btn-primary"
                        onClick={() => this.AllDataSubmit()}
                      >
                        Create New Asset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Drawer>

        <Drawer
          maskClosable={false}
          title={"Update Renewable Energy Wind"}
          width={"60%"}
          placement="right"
          onClose={() => this.onDrawerClose()}
          visible={this.state.openEdit}
          closeIcon={
            <button
              type="button"
              class="btn btn-soft-danger btn-icon-square-sm"
              style={{ marginRight: "8px" }}
            >
              <i class="mdi dripicons-cross"></i>
            </button>
          }
        >
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <Form ref={this.formRef}>
                    <div className="row"></div>
                    <div className="row"></div>

                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          Wind Turbine Capacity Of a Single Unit (kW){" "}
                          <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item>
                          <Input
                            id="perWindTurbineCapacity"
                            value={this.state.rewPerWindTurbineCapacity}
                            onChange={this.handleperWindTurbineCapacity}
                          />
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Wind Turbine Capacity of a single unit (kW)",
                              this.state.rewPerWindTurbineCapacity,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label" for="depot">
                          Wind Turbine Count <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item>
                          {/* <InputNumber style={{ width: '100%' }} id="windTurbineCount" value={this.state.rewWindTurbineCount} onChange={this.handleWindTurbineCount} /> */}
                          <div>
                            <Select
                              style={{ width: "100%" }}
                              value={this.state.rewWindTurbineCount}
                              id="windTurbineCount"
                              onChange={(e) => {
                                this.handleWindTurbineCount(e);
                              }}
                            >
                              {this.props.windDropdown["dropdownObjWind"][
                                "rewWindTurbineCount"
                              ]?.map((x) => {
                                return <Option value={x}>{x}</Option>;
                              })}
                            </Select>
                          </div>
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Wind Turbine Count",
                              this.state.rewWindTurbineCount,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          Installed Location <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item>
                          <div>
                            <Select
                              value={this.state.rewInstalledLocation}
                              style={{ width: "100%" }}
                              id="installedLocation"
                              onChange={(e) => {
                                this.handleInstalledLocation(e);
                              }}
                            >
                              {this.props.windDropdown["dropdownObjWind"][
                                "rewInstalledLocation"
                              ]?.map((x) => {
                                return <Option value={x}>{x}</Option>;
                              })}
                            </Select>
                          </div>
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Installed Location",
                              this.state.rewInstalledLocation,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          Installed Height (m) <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item>
                          <InputNumber
                            style={{ width: "100%" }}
                            id="installedHeight"
                            value={this.state.rewInstalledHeight}
                            onChange={this.handleInstalledHeight}
                          />
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              " Installed Height",
                              this.state.rewInstalledHeight,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label" for="depot">
                          Commissioned Date
                        </label>
                        {this.state.rewCommissionedDate != null ? (
                          <Form.Item>
                            <DatePicker
                              defaultValue={
                                this.state.rewCommissionedDate != ""
                                  ? moment(this.state.rewCommissionedDate)
                                  : ""
                              }
                              style={{ width: "100%" }}
                              onChange={this.onChangeCommissionedDate}
                            />
                          </Form.Item>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label" for="depot">
                          Make <x style={{ color: "red" }}>*</x>
                        </label>
                        {this.state.selectedMakeId != null ? (
                          <Form.Item
                            required
                            name="Is_active"
                            tooltip="This is a required field"
                          >
                            <Select
                              showSearch
                              onChange={this.onChangeMake}
                              defaultValue={this.state.selectedMakeId}
                              style={{ width: "100%" }}
                              placeholder="Search to Select"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {this.props.rewMasterData?.rewMasterData?.rewMakelList?.map(
                                (item, index) => {
                                  return (
                                    <Option value={item?.id}>
                                      {item?.name}
                                    </Option>
                                  );
                                }
                              )}
                            </Select>
                            <p style={{ color: "#f5325c" }}>
                              {this.validator.message(
                                "Make",
                                this.state.selectedMakeId,
                                "required"
                              )}
                            </p>
                          </Form.Item>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          RMS connection Inband/Outband
                        </label>
                        <Form.Item>
                          <div>
                            <Select
                              style={{ width: "100%" }}
                              value={this.state.rewRmsconnectionInband}
                              id="rmsconnectionInband"
                              onChange={(e) => {
                                this.handleRmsconnectionInband(e);
                              }}
                            >
                              {this.props.windDropdown["dropdownObjWind"][
                                "rewRmsconnectionInband"
                              ]?.map((x) => {
                                return <Option value={x}>{x}</Option>;
                              })}
                            </Select>
                          </div>
                        </Form.Item>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          RMS Connection Mode
                        </label>
                        <Form.Item>
                          <Select
                            showSearch
                            style={{ width: "100%" }}
                            value={this.state.rewRmsconnectionMode}
                            id="rmsconnectionMode"
                            onChange={(e) => {
                              this.handleRmsconnectionMode(e);
                            }}
                          >
                            {this.props?.windDropdown["dropdownObjWind"][
                              "rewRmsconnectionMode"
                            ]?.map((x) => {
                              return <Option value={x}>{x}</Option>;
                            })}
                          </Select>
                        </Form.Item>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label" for="dcdu">
                          Energy feed onto the DC/AC bus{" "}
                          <x style={{ color: "red" }}>*</x>
                        </label>
                        <Form.Item>
                          <div>
                            <Select
                              style={{ width: "100%" }}
                              value={this.state.rewEnergyFeed}
                              id="energyFeed"
                              onChange={(e) => {
                                this.handleEnergyFeed(e);
                              }}
                            >
                              {this.props.windDropdown["dropdownObjWind"][
                                "rewEnergyFeed"
                              ]?.map((x) => {
                                return <Option value={x}>{x}</Option>;
                              })}
                            </Select>
                          </div>
                          <p style={{ color: "#f5325c" }}>
                            {this.validator.message(
                              "Energy feed onto the DC/AC bus",
                              this.state.rewEnergyFeed,
                              "required"
                            )}
                          </p>
                        </Form.Item>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label" for="depot">
                          Rectifiers <x style={{ color: "red" }}>*</x>
                        </label>
                        {this.state.selectedRectifierList.length > 0 ? (
                          <Form.Item
                            required
                            name="Is_active"
                            tooltip="This is a required field"
                          >
                            <Select
                              mode="multiple"
                              showSearch
                              defaultValue={this.state.selectedRectifierList}
                              onChange={this.onChangeRectifier}
                              style={{ width: "100%" }}
                              placeholder="Search to Select"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {this.props.rewMasterData?.rewMasterData?.rectifierList?.map(
                                (item, index) => {
                                  return (
                                    <Option value={item?.id}>
                                      {item?.name}
                                    </Option>
                                  );
                                }
                              )}
                            </Select>
                            <p style={{ color: "#f5325c" }}>
                              {this.validator.message(
                                "Rectifiers",
                                this.state.rectifier,
                                "required"
                              )}
                            </p>
                          </Form.Item>
                        ) : (
                          ""
                        )}
                        {this.state.selectedRectifierList.length == 0 ? (
                          <Form.Item
                            required
                            name="Is_active"
                            tooltip="This is a required field"
                          >
                            <Select
                              mode="multiple"
                              showSearch
                              onChange={this.onChangeRectifier}
                              style={{ width: "100%" }}
                              placeholder="Search to Select"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {this.props.rewMasterData?.rewMasterData?.rectifierList?.map(
                                (item, index) => {
                                  return (
                                    <Option value={item?.id}>
                                      {item?.name}
                                    </Option>
                                  );
                                }
                              )}
                            </Select>
                            <p style={{ color: "#f5325c" }}>
                              {this.validator.message(
                                "Rectifiers",
                                this.state.rectifier,
                                "required"
                              )}
                            </p>
                          </Form.Item>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="row"></div>
                    <div className="row"></div>
                  </Form>
                  <div className="row" style={{ justifyContent: "end" }}>
                    <div className="col-md-2">
                      {" "}
                      <button
                        className="btn btn-primary"
                        onClick={() => this.AllDataSubmitUpdate()}
                      >
                        Update That Asset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
}
export default Rew;
